import type { ComponentProps } from 'react'
import { cn } from './cn.js'

export interface PillProps extends ComponentProps<'button'> {
  active?: boolean
  /** Tabular numerals for quantity and time pills. */
  numeric?: boolean
}

/**
 * Selectable chip — quantity presets, cooking methods, hour picks, candidate
 * matches. One visual language for "chosen" everywhere: solid accent, the same
 * statement the primary button makes. The before-layer stretches the tap
 * target toward 44px while the visible pill stays dense.
 */
export function Pill({
  active = false,
  numeric = false,
  className,
  type = 'button',
  ...props
}: PillProps) {
  return (
    <button
      type={type}
      aria-pressed={active}
      className={cn(
        'relative inline-flex h-9 select-none items-center justify-center whitespace-nowrap',
        'rounded-[var(--radius-control)] border px-3 text-sm transition-colors duration-[140ms]',
        "before:absolute before:-inset-y-1 before:inset-x-0 before:content-['']",
        numeric && 'tnum',
        active
          ? 'border-accent bg-accent font-semibold text-accent-ink'
          : 'border-line text-dim hover:border-line-strong hover:text-ink',
        className,
      )}
      {...props}
    />
  )
}
